import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 5.5V4.5C20 4.36739 19.9473 4.24021 19.8536 4.14645C19.7598 4.05268 19.6326 4 19.5 4H15V3C15 2.73478 14.8946 2.48043 14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2H10C9.73478 2 9.48043 2.10536 9.29289 2.29289C9.10536 2.48043 9 2.73478 9 3V4H4.5C4.36739 4 4.24021 4.05268 4.14645 4.14645C4.05268 4.24021 4 4.36739 4 4.5V5.5C4 5.63261 4.05268 5.75979 4.14645 5.85355C4.24021 5.94732 4.36739 6 4.5 6H19.5C19.6326 6 19.7598 5.94732 19.8536 5.85355C19.9473 5.75979 20 5.63261 20 5.5ZM6.50307 21.4646C6.13177 21.1192 5.90549 20.6458 5.87 20.14L5 8H19L18.15 20.14C18.1145 20.6458 17.8882 21.1192 17.5169 21.4646C17.1456 21.8099 16.657 22.0012 16.15 22H7.87C7.36296 22.0012 6.87436 21.8099 6.50307 21.4646Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgDelete = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDelete;
